<template>
  <div style="padding-top:40px">
    <div class="win" :style="'background-image:url('+oss+data.style.backgroundImage+');background-size:100% 100%;background-color:'+data.style.backgroundColor">
      <div class="head" :style="'color:'+data.style.titleColor">
        完善资料
        <p class="des" :style="'color:'+data.style.desColor">为了更好的为您提供服务请您完善资料</p>
      </div>
      <div class="main" :style="'color:'+data.style.color">
        <div class="form_item">
          <div class="label">姓名</div>
          <div class="input">请输入收货人姓名</div>
        </div>
        <div class="form_item">
          <div class="label">手机号</div>
          <div class="input">请输入收货人姓名</div>
        </div>

        <div class="form_item">
          <div class="label">验证码</div>
          <div class="input">请输入验证码</div>
          <div class="code" :style="'background-color:'+data.style.buttonColor+';color:'+data.style.buttonTextColor">获取验证码</div>
        </div>
        <div class="form_item" style="data.style.buttonColor">
          <div class="label">性别</div>
          <span><input type="radio" checked class="m-r-5" name="sex" id="undef" :data-color="data.style.buttonColor"><label for="undef" :data-color="data.style.buttonColor" ></label> 未知</span>
          <span><input type="radio" class="m-l-30" name="sex" id="man" :data-color="data.style.buttonColor"> <label for="man" class=" m-r-5" :data-color="data.style.buttonColor"> </label> 男</span>
          <span><input type="radio" class="m-l-30  " name="sex" id="women" :data-color="data.style.buttonColor"> <label for="women" class="m-r-5 " :data-color="data.style.buttonColor"></label> 女</span>
        </div>
        <div class="form_item">
          <div class="label">生日</div>
          <div class="input">请选择您的出生日期</div>
        </div>
        <div class="button" :style="'background-image:url('+oss+data.style.backgroundButtomImage+');background-size:100%;background-color:'+data.style.buttonColor+';color:'+data.style.buttonTextColor">领取奖品</div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config";
export default {
  name: "collect",
  props: { data: Object },
  setup() {
    const oss = config.oss[process.env.VUE_APP_type];

    return {
      oss,
    };
  },
};
</script>

<style lang="less" scoped>
.win {
  width: 300px;
  height: 465px;
  margin: 0 auto;
  position: relative;
  background-color: #fff;
  border-radius: 10px;
  padding: 15px;
  .head {
    width: 100%;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 15px;
    .des {
      font-size: 14px;
      font-weight: normal;
      color: #999999;
    }
  }
  .main {
    width: 100%;
    font-size: 15px;
    .form_item {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .label {
        width: 50px;
        height: 46px;
        line-height: 46px;
        text-align: center;
        margin-right: 10px;
      }
      label {
        position: relative;
        &::before {
          content: "";
          width: 18px;
          height: 18px;
          border: 1px solid #333;
          border-radius: 50%;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: -18px;
        }
      }
      input {
        opacity: 0;
        &:checked~label::before {
          border: 1px solid inherit;
          z-index: 1;

        }
        &:checked~label::after{
          content: '';
          width: 9px;
          height: 9px;
          left: -13px;
          border-radius: 100%;
          position: absolute;
          background-color: inherit;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .input {
        height: 46px;
        line-height: 46px;
        background-color: #f8f8f8;
        padding-left: 10px;
        font-size: 14px;
        color: #999;
        flex: 1;
        border-radius: 6px;
      }
      .code {
        background: #ff0e41;
        color: #fff;
        width: 100px;
        height: 46px;
        line-height: 46px;
        text-align: center;
        font-size: 14px;
        margin-left: 10px;
        border-radius: 6px;
      }
    }

    .button {
      width: 150px;
      height: 44px;
      background: #ff0e41;
      border-radius: 22px;
      text-align: center;
      line-height: 44px;
      color: #fff;
      margin: 0 auto;
      margin-top: 40px;
    }
  }
}
</style>